import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link, browserHistory } from 'react-router';
import { lazyload } from 'react-lazyload';
import i18n from 'kodyl-js/i18n/react';
import IconList from '../common/icon/icon-list';
import { imageUrl /*, imageBlur*/, staticMap } from '../utils/image-url';

@i18n
class DwellingsSingle extends Component {
  labelProps(createdAt, deletedAt) {
    if (deletedAt) {
      return {
        style: 'danger',
        text: this.i18n('Rented %s', deletedAt)
      };
    }
    if (createdAt) {
      return {
        style: 'primary',
        text: this.i18n('Created %s', createdAt)
      };
    }
    return null;
  }

  goto = ev => {
    if (!/a/i.test(ev.target.nodeName)) {
      browserHistory.push(this.props.link);
    }
  };

  render() {
    const { dwelling, link } = this.props;

    const {
      headline,
      teaser,
      rent,
      rooms,
      size,
      city,
      street,
      // zip,
      lat,
      lng,
      image,
      createdAt,
      deletedAt
    } = dwelling;

    const validLocation = (lat && lng) || false;
    // const validLocation = (city && street && zip) || false;
    const vacant = !deletedAt;
    const label = this.labelProps(createdAt, deletedAt);

    const btnLabel = `${this.i18n('Show dwelling')} »`;
    const btn = vacant ? (
      <Link to={link} title={headline} className="btn hidden-xs">
        {btnLabel}
      </Link>
    ) : (
      <button className="btn hidden-xs" disabled>
        {btnLabel}
      </button>
    );

    const imageSrc =
      image && vacant
        ? imageUrl(image)
        : validLocation
        ? staticMap(lat, lng) // staticMap(street, city, zip)
        : null;

    const className = [
      'search-result',
      vacant ? 'listing-vacant' : 'listing-rented',
      createdAt && 'listing-new'
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <li
        className={className}
        onClick={vacant ? this.goto : null}
        data-remark={label && label.text}
      >
        <h4 className="visible-xs">
          {vacant ? <Link to={link}>{headline}</Link> : headline}
        </h4>
        <Row>
          <Col xs={3}>
            {imageSrc ? (
              <img src={imageSrc} className="img-responsive" />
            ) : null}
            {/* {image && imageBlur() ? (
              <div style={{ overflow: 'hidden' }}>{imageElement}</div>
            ) : (
              imageElement
            )} */}
          </Col>
          <Col xs={9}>
            <h4 className="hidden-xs">
              {vacant ? <Link to={link}>{headline}</Link> : headline}
            </h4>
            {btn}
            <p className="hidden-xs">
              {label && (
                <span className={`label label-${label.style}`}>
                  {label.text}
                </span>
              )}
              {teaser}
            </p>
            <div className="clearfix" />
            <IconList data={{ rent, rooms, size, city, street }} />
          </Col>
        </Row>
      </li>
    );
  }
}

export default DwellingsSingle;

export const Lazy = __CLIENT__
  ? lazyload({
      offset: 500,
      placeholder: <div className="dwelling-in-list" />
    })(DwellingsSingle)
  : DwellingsSingle;
